import { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  TextField,
  MenuItem,
  Button,
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export function Contact(): JSX.Element {
  const [form, setForm] = useState({
    name: '',
    goal: '',
    time: '',
    message: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSend = () => {
    const { name, goal, time, message } = form;
    const whatsappNumber = '972506660706'; // מספר וואטסאפ של גלית
    const text = `היי גלית
שמי ${name}.
הייתי רוצה לתרגל יוגה כדי ${goal}.
יהיה לי מתאים לתרגל ${time}.
${message ? message + '. ' : ''}אשמח לשמוע ממך`;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      text
    )}`;
    window.open(url, '_blank');
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }} dir="rtl" id="contact">
      <Typography variant="h4" align="center" gutterBottom>
        צרו קשר 🌿
      </Typography>
      <Typography align="center" color="text.secondary" sx={{ mb: 4 }}>
        מלאו את הפרטים וניצור איתכם קשר דרך וואטסאפ
      </Typography>

      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        sx={{ textAlign: 'right', width: '100%' }}
      >
        <TextField
          label="שם מלא"
          name="name"
          value={form.name}
          onChange={handleChange}
          fullWidth
          required
        />

        <TextField
          select
          label="מטרה"
          name="goal"
          value={form.goal}
          onChange={handleChange}
          fullWidth
          required
          SelectProps={{
            MenuProps: {
              disablePortal: true,
              anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
              transformOrigin: { vertical: 'top', horizontal: 'right' },
            },
          }}
        >
          <MenuItem value="להפחית מתחים">להפחית מתחים</MenuItem>
          <MenuItem value="להקל על כאבים">להקל על כאבים</MenuItem>
          <MenuItem value="להתחזק פיזית">להתחזק פיזית</MenuItem>
          <MenuItem value="להיות רגוע/ה יותר">להיות רגוע/ה יותר</MenuItem>
          <MenuItem value="לשפר גמישות">לשפר גמישות</MenuItem>
          <MenuItem value="סיבה אחרת">סיבה אחרת</MenuItem>
        </TextField>

        <TextField
          select
          label="מתי נוח לך לתרגל?"
          name="time"
          value={form.time}
          onChange={handleChange}
          fullWidth
          required
          SelectProps={{
            MenuProps: {
              disablePortal: true,
              anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
              transformOrigin: { vertical: 'top', horizontal: 'right' },
            },
          }}
        >
          <MenuItem value="בשעות הבוקר">בשעות הבוקר</MenuItem>
          <MenuItem value="בשעות הערב">בשעות הערב</MenuItem>
        </TextField>

        <TextField
          label="הודעה נוספת (לא חובה)"
          name="message"
          value={form.message}
          onChange={handleChange}
          fullWidth
          multiline
          rows={3}
        />

        <Button
          variant="contained"
          color="success"
          size="large"
          startIcon={<WhatsAppIcon sx={{ ml: 1.5 }} />} // מרחק בין האייקון לטקסט
          onClick={handleSend}
          disabled={!form.name || !form.goal || !form.time}
        >
          שלחו הודעה בוואטסאפ
        </Button>
      </Box>
    </Container>
  );
}
